import {
  FETCH_ACTIVITY_BOARD,
  FETCH_ACTIVITY_BOARD_SUCCESS,
  FETCH_ACTIVITY_BOARD_FAILURE,
} from "./constants";

export const fetchActivityBoard = (payload) => ({
  type: FETCH_ACTIVITY_BOARD,
  payload, // { id: <location uuid>, from?: 'Y-MM-DD', to?: 'Y-MM-DD' }
});
export const fetchActivityBoardSuccess = (payload) => ({
  type: FETCH_ACTIVITY_BOARD_SUCCESS,
  payload,
});
export const fetchActivityBoardFailure = () => ({
  type: FETCH_ACTIVITY_BOARD_FAILURE,
});
